import { render, staticRenderFns } from "./editTutorial.vue?vue&type=template&id=7512896a&scoped=true&lang=html&"
import script from "./editTutorial.vue?vue&type=script&lang=js&"
export * from "./editTutorial.vue?vue&type=script&lang=js&"
import style0 from "./editTutorial.vue?vue&type=style&index=0&id=7512896a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512896a",
  null
  
)

export default component.exports